import keyMirror from "key-mirror-nested";

const FETCH_ACTIONS = {
    FETCH: null,
    FETCHED: null,
    FAILED_FETCH: null,
};
const CREATE_ACTIONS = {
    CREATE: null,
    CREATED: null,
    FAILED_CREATE: null,
};
const UPDATE_ACTIONS = {
    UPDATE: null,
    UPDATED: null,
    FAILED_UPDATE: null,
};

const BANK_ACCOUNT_ACTIONS = new keyMirror({
    BANK_ACCOUNTS: {
        LIST: {
            ...FETCH_ACTIONS
        },
        ACCOUNT: {
            ...CREATE_ACTIONS,
            ...UPDATE_ACTIONS
        }
    },
    LENDER_ACCOUNTS: {
        LIST: {
            ...FETCH_ACTIONS
        },
        ACCOUNT: {
            ...CREATE_ACTIONS,
            ...UPDATE_ACTIONS
        }
    }
});

export default BANK_ACCOUNT_ACTIONS;